module.exports = __webpack_public_path__ + "resources/images/zorgkosten-0963cc619b5fe75bc73da4a2f9c1ceeb-cache.jpg";